<script lang="ts">
    import {getTimeLine, postTimeLine} from "$lib/calls/timeline.js";
    import relativeTime from "dayjs/plugin/relativeTime";
    import dayjs from "dayjs";
    import {onMount} from "svelte";
    import {availableProjectLeaders} from "$lib/calls/customer";
    import Avatar from "$lib/components/Avatar.svelte";
    import {user} from "$lib/stores/auth";
    import UnitAvatar from "$lib/components/UnitAvatar.svelte";
    import {userAsAssociate, userCustomer} from "$lib/stores/customer";
    import {Timeline, TimelineItem, Button, Spinner} from 'flowbite-svelte';
    import {BullhornOutline, ExclamationCircleSolid} from "flowbite-svelte-icons";
    export let project;

    let associates = [];
    onMount(async ()=> {
        associates = await availableProjectLeaders()
    })
    let timelineItems = [];
    let newTimelineItem = {
        title: 'hat kommentiert',
        description: '',
    }
    const comment = async () => {
        const item = await postTimeLine(project, newTimelineItem)
        newTimelineItem.description = ''
        timelineItems = [item, ...timelineItems];
    }

    const load = async () => {
        timelineItems = await getTimeLine(project)
        return timelineItems;
    }

    dayjs.locale('de')
    dayjs.extend(relativeTime)
    let localUser;
    let recrewMembers = [];
    //TODO: recrew members have to be loaded
    user.subscribe(user => {
        localUser = user
    })

    let ownAssociation;
    userAsAssociate.subscribe(x => {
        ownAssociation = x
    })


</script>
<div class="max-h-full pb-12">
    {#await load()}
        <div class="text-center my-5">
            <Spinner/>
        </div>
    {:then}
            <Timeline order="vertical">
                <TimelineItem  date="Neuer Kommentar">
                    <div class="absolute -left-5 -top-2" slot="icon">
                        <Avatar size="md" associate={ownAssociation}/>
                    </div>

                    <form on:submit|preventDefault={comment} class="relative">
                        <div class="overflow-hidden rounded-lg shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-primary-600">
                            <label for="comment" class="sr-only">Nachricht...</label>
                            <textarea bind:value={newTimelineItem.description} rows="3" name="comment" id="comment" class="block w-full resize-none border-0 bg-transparent py-1.5 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6" placeholder="Nachricht..."></textarea>

                            <!-- Spacer element to match the height of the toolbar -->
                            <div class="py-2" aria-hidden="true">
                                <!-- Matches height of button in toolbar (1px border + 36px content height) -->
                                <div class="py-px">
                                    <div class="h-9"></div>
                                </div>
                            </div>
                        </div>

                        <div class="absolute inset-x-0 bottom-0 flex justify-between py-2 pl-3 pr-2">
                            <div class="isolate flex -space-x-1">
                                <UnitAvatar/>
                                <Avatar bgColor="bg-blue-600" size="md" associate={project.responsibleUser?.associations?.find(x => x.customerId === project.customerId)}/>
                                {#each project.associates as team}
                                    <Avatar size="sm" associate={associates.find(x => x.id === team.associateId)}/>
                                {/each}
                            </div>

                            <div class="flex-shrink-0">
                                <Button type="submit">Abschicken</Button>
                            </div>
                        </div>
                    </form>
                </TimelineItem>
                {#each timelineItems as item}
                    <TimelineItem title={item.title}  date={dayjs(item.createdAt.value).fromNow()}>
                        <svelte:fragment slot="icon">

                            <span class="flex absolute -left-3 justify-center items-center w-6 h-6 bg-primary-200 rounded-full ring-8 ring-white dark:ring-gray-900 dark:bg-primary-900">
                            {#if item.type === 'important'}
                                <ExclamationCircleSolid class="w-6 h-6 text-red-400 dark:text-red-200" />
                            {:else if item.type === 'avatar'}
                                <Avatar size="sm" associate={associates.find(x => x.userId === item.userId)}/>
                            {:else}
                                <BullhornOutline class="w-4 h-4 text-primary-700 dark:text-primary-200" />
                            {/if}
                          </span>
                        </svelte:fragment>

                        <p class="text-neutral-600 dark:text-gray-200">{@html item.description}</p>
                        <p class="text-sm text-neutral-500">{dayjs(item.createdAt.value).format('DD.MM.YYYY')}</p>
                    </TimelineItem>
                {/each}
            </Timeline>
        <!--<div class="flex gap-x-4 mt-4 relative pl-2">
            <div class="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                <div class="w-px bg-gray-200"></div>
            </div>
            <div class="flex-shrink-0 -ml-2 z-10">
                <Avatar size="md" associate={ownAssociation}/>
            </div>

            <div class="min-w-0 flex-1">
                <form on:submit|preventDefault={comment} class="relative">
                    <div class="overflow-hidden rounded-lg shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-primary-600">
                        <label for="comment" class="sr-only">Nachricht...</label>
                        <textarea bind:value={newTimelineItem.description} rows="3" name="comment" id="comment" class="block w-full resize-none border-0 bg-transparent py-1.5 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6" placeholder="Nachricht..."></textarea>

                        &lt;!&ndash; Spacer element to match the height of the toolbar &ndash;&gt;
                        <div class="py-2" aria-hidden="true">
                            &lt;!&ndash; Matches height of button in toolbar (1px border + 36px content height) &ndash;&gt;
                            <div class="py-px">
                                <div class="h-9"></div>
                            </div>
                        </div>
                    </div>

                    <div class="absolute inset-x-0 bottom-0 flex justify-between py-2 pl-3 pr-2">
                        <div class="isolate flex -space-x-1">
                            <UnitAvatar/>
                            <Avatar bgColor="bg-blue-600" size="md" associate={project.responsibleUser?.associations?.find(x => x.customerId === project.customerId)}/>
                            {#each project.associates as team}
                                <Avatar size="sm" associate={associates.find(x => x.id === team.associateId)}/>
                            {/each}
                        </div>

                        <div class="flex-shrink-0">
                            <button type="submit" class="inline-flex items-center rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">Abschicken</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <ul role="list" class="mt-6 space-y-6">
            {#each timelineItems as item}
                {#if item.type === 'info'}
                    <li class="relative flex gap-x-4 pr-3">
                        <div class="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                            <div class="w-px bg-gray-200"></div>
                        </div>
                        <div class="relative flex h-6 w-6 flex-none items-center justify-center">
                            <div class="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300"></div>
                        </div>
                        <p class="flex-auto py-0.5 text-xs leading-5 text-gray-500"><span class="font-medium text-gray-900">{item.title}</span><br> {@html item.description}</p>
                        <time datetime={item.createdAt.value} class="flex-none py-0.5 text-xs leading-5 text-gray-500">{dayjs(item.createdAt.value).toNow(true)}</time>
                    </li>
                {:else if item.type === 'avatar'}
                    <li class="relative flex gap-x-4">
                        <div class="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                            <div class="w-px bg-gray-200"></div>
                        </div>
                        <Avatar size="sm" associate={associates.find(x => x.userId === item.userId)}/>
                        <div class="flex-auto rounded-md p-3 ring-1 ring-inset ring-gray-200">
                            <div class="flex justify-between gap-x-4">
                                <div class="py-0.5 text-xs leading-5 text-gray-500"><span class="font-medium text-gray-900">{associates.find(x => x.userId === item.userId)?.name}</span>:</div>
                                <time datetime="2023-01-23T15:56" class="flex-none py-0.5 text-xs leading-5 text-gray-500">{dayjs(item.createdAt.value).toNow(true)}</time>
                            </div>
                            <p class="text-sm leading-6 text-gray-500">{item.description}</p>
                        </div>
                    </li>
                {:else }
                    <li class="relative flex gap-x-4 pr-4">
                        &lt;!&ndash;<div class="absolute left-0 top-0 flex w-6 justify-center h-6">
                            <div class="w-px bg-gray-200"></div>
                        </div>&ndash;&gt;
                        <div class="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                            <div class="w-px bg-gray-200"></div>
                        </div>
                        <div class="relative flex h-6 w-6 flex-none items-center justify-center">
                            <svg class="h-6 w-6 text-indigo-600" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                            </svg>
                        </div>
                        <p class="flex-auto py-0.5 text-xs leading-5 text-gray-500"><span class="font-medium text-gray-900">{item.title}</span><br> {@html item.description}</p>
                        <time datetime="2023-01-24T09:20" class="flex-none py-0.5 text-xs leading-5 text-gray-500">{dayjs(item.createdAt.value).toNow(true)}</time>
                    </li>
                {/if}
            {/each}

        </ul>-->
    {/await}
</div>
